export function capFirst(string) {
    const text = string.toLowerCase();
    return text.charAt(0).toUpperCase() + text.slice(1);
}

export function ucWords(string) {
    let text = string.toLowerCase();
    return text.replace(/(^([a-zA-Z\p{M}]))|([ -][a-zA-Z\p{M}])/g, function (s) {
        return s.toUpperCase();
    });
}

export function generateId(length = 12) {
    const charSet = 'abcdefghijklmnopqrstuvwxyz0123456789';
    let id = '';
    for (let i = 0; i < length; i++) {
        const index = Math.random() * charSet.length;
        id += charSet.charAt(index);
    }
    return id;
}

export function formatCurrency(value) {
    const amount = parseFloat(value);
    if (isNaN(amount)) return '0.00';

    return Number(amount)
        .toFixed(2)
        .replace(/\d(?=(\d{3})+\.)/g, '$&,');
}
